import React, { Component, Fragment } from "react";
import utils from "../../../utils/utils";

export default class TabelaFaculdade extends Component {

    constructor(props) {
        super(props);
    }

    calculaTotal = (dados, realizados) => {

        let valorRealizado = realizados && realizados[realizados && realizados.findIndex(v => v.unidade === utils.getUnidadeRealizado(dados.unidade))];

        let total = {
            matricula_regimental: 0,
            matricula_nao_regimental: 0,
            matricula_pago: 0,
            hora_regimental: 0,
            hora_nao_regimental: 0,
            hora_pago: 0,
            r_matricula_regimental: 0,
            r_matricula_nao_regimental: 0,
            r_matricula_pago: 0,
            r_hora_regimental: 0,
            r_hora_nao_regimental: 0,
            r_hora_pago: 0,
        }

        if (dados) {
            Object.keys(dados.modalidades).map((modalidade, i) => {
                if(modalidade.indexOf("Graduaç") === -1 && modalidade.indexOf("Extensão") === -1) return;
                total["matricula_regimental"]     += dados.modalidades[modalidade]["matricula_regimental"]
                total["matricula_nao_regimental"] += dados.modalidades[modalidade]["matricula_nao_regimental"]
                total["matricula_pago"]           += dados.modalidades[modalidade]["matricula_pago"]
                total["hora_regimental"]          += dados.modalidades[modalidade]["hora_regimental"]
                total["hora_nao_regimental"]      += dados.modalidades[modalidade]["hora_nao_regimental"]
                total["hora_pago"]                += dados.modalidades[modalidade]["hora_pago"]
            });
        }

        if (valorRealizado) {
            Object.keys(valorRealizado.modalidades).map((modalidade, i) => {
                if(modalidade.indexOf("91 Pós") === -1 && modalidade.indexOf("41 Gra") === -1 && modalidade.indexOf("87 Cur") === -1) return;
                total["r_matricula_regimental"]     += valorRealizado.modalidades[modalidade]["matricula_regimental"]
                total["r_matricula_nao_regimental"] += valorRealizado.modalidades[modalidade]["matricula_nao_regimental"]
                total["r_matricula_pago"]           += valorRealizado.modalidades[modalidade]["matricula_pago"]
                total["r_hora_regimental"]          += valorRealizado.modalidades[modalidade]["hora_regimental"]
                total["r_hora_nao_regimental"]      += valorRealizado.modalidades[modalidade]["hora_nao_regimental"]
                total["r_hora_pago"]                += valorRealizado.modalidades[modalidade]["hora_pago"]
            });
        }

        return total;

    }

    render() {

        let { dados, mesSelecionado, realizados, isAcumulado, radioChecked, acumulado } = this.props;
        let totais;
        realizados = this.props.verificaSePossuiRealizado(realizados, mesSelecionado)

        if(isAcumulado) {
            dados = { ...acumulado }
        }

        let valor = dados[mesSelecionado][dados[mesSelecionado].length-1]
        let total = this.calculaTotal(valor, realizados);
        
        return (
            <Fragment>
                
                <tr>
                    <td colSpan="19" style={{ textAlign: "center", fontWeight: "600", backgroundColor: "#c5c0ad", fontSize: "14px" }}>FACULDADE</td>
                </tr>
                {utils.retornaArrayModalidades().map((modal, j) => {
                    
                    // Verifica Faculdade
                    if(modal.indexOf("91 Pós") === -1 && modal.indexOf("41 Gra") === -1 && modal.indexOf("87 Cur") === -1) return;

                    let valorRealizado, modalidade, valorMeta;
                    modalidade=modal;

                    try {
                        valorRealizado = realizados && realizados[realizados && realizados.findIndex(v => v.unidade === utils.getUnidadeRealizado(valor.unidade))];
                        valorRealizado = utils.verificaValorModalidade(valorRealizado, modal);
                        modal = utils.getModalidades(modal, true);

                        valorMeta = valor.modalidades[modal];
                        if(valorMeta === undefined) {
                            valorMeta = {
                                hora_nao_regimental: 0,
                                hora_pago: 0,
                                hora_regimental: 0,
                                matricula_nao_regimental: 0,
                                matricula_pago: 0,
                                matricula_regimental: 0,
                            }
                        }

                    } catch (error) {
                    }
                    
                    // Omitir modalidades com os valores zerados
                    {
                        let somaIs0Meta = Object.keys(valorMeta).reduce((acc, atual) => acc + valorMeta[atual], 0);
                        let somaIs0Realizado = Object.keys(valorRealizado).reduce((acc, atual) => acc + valorRealizado[atual], 0);
                        if(somaIs0Meta + somaIs0Realizado < 1) return;
                    }
                    // FIM - Omitir modalidades com os valores zerados

                    return (
                        <tr>
                            <td className="text-start" style={{ backgroundColor: "#c5c0ad" }}>{modalidade}</td>
                            <td>{utils.formataNumero(valorMeta["matricula_regimental"])}</td>
                            <td>{utils.formataNumero(valorMeta["matricula_nao_regimental"])}</td>
                            <td>{utils.formataNumero(valorMeta["matricula_pago"])}</td>
                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valorMeta["matricula_pago"] + valorMeta["matricula_nao_regimental"] + valorMeta["matricula_regimental"])}</td>
                            <td>{utils.formataNumero(valorRealizado["matricula_regimental"])}</td>
                            <td>{utils.formataNumero(valorRealizado["matricula_nao_regimental"])}</td>
                            <td>{utils.formataNumero(valorRealizado["matricula_pago"])}</td>
                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valorRealizado["matricula_regimental"] + valorRealizado["matricula_nao_regimental"] + valorRealizado["matricula_pago"])}</td>
                            <td style={{ fontWeight: "600", backgroundColor: "#9d9475" }}>{utils.formataPercentual(valorMeta, valorRealizado, "matricula")}</td>
                            <td>{utils.formataNumero(valorMeta["hora_regimental"])}</td>
                            <td>{utils.formataNumero(valorMeta["hora_nao_regimental"])}</td>
                            <td>{utils.formataNumero(valorMeta["hora_pago"])}</td>
                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valorMeta["hora_pago"] + valorMeta["hora_nao_regimental"] + valorMeta["hora_regimental"])}</td>
                            <td>{utils.formataNumero(valorRealizado["hora_regimental"])}</td>
                            <td>{utils.formataNumero(valorRealizado["hora_nao_regimental"])}</td>
                            <td>{utils.formataNumero(valorRealizado["hora_pago"])}</td>
                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valorRealizado["hora_regimental"] + valorRealizado["hora_nao_regimental"] + valorRealizado["hora_pago"])}</td>
                            <td style={{ fontWeight: "600", backgroundColor: "#9d9475" }}>{utils.formataPercentual(valorMeta, valorRealizado, "hora")}</td>
                        </tr>
                    )
                })}
                <tr style={{ fontWeight: "700", backgroundColor: "#c5c0ad" }}>
                    <td>Total</td>
                    <td>{utils.formataNumero(total["matricula_regimental"])}</td>
                    <td>{utils.formataNumero(total["matricula_nao_regimental"])}</td>
                    <td>{utils.formataNumero(total["matricula_pago"])}</td>
                    <td>{utils.formataNumero(total["matricula_pago"] + total["matricula_nao_regimental"] + total["matricula_regimental"])}</td>
                    <td>{utils.formataNumero(total["r_matricula_regimental"])}</td>
                    <td>{utils.formataNumero(total["r_matricula_nao_regimental"])}</td>
                    <td>{utils.formataNumero(total["r_matricula_pago"])}</td>
                    <td>{utils.formataNumero(total["r_matricula_regimental"] + total["r_matricula_nao_regimental"] + total["r_matricula_pago"])}</td>
                    <td>{utils.formataPercentualTotal(total, "matricula")}</td>
                    <td>{utils.formataNumero(total["hora_regimental"])}</td>
                    <td>{utils.formataNumero(total["hora_nao_regimental"])}</td>
                    <td>{utils.formataNumero(total["hora_pago"])}</td>
                    <td>{utils.formataNumero(total["hora_pago"] + total["hora_nao_regimental"] + total["hora_regimental"])}</td>
                    <td>{utils.formataNumero(total["r_hora_regimental"])}</td>
                    <td>{utils.formataNumero(total["r_hora_nao_regimental"])}</td>
                    <td>{utils.formataNumero(total["r_hora_pago"])}</td>
                    <td>{utils.formataNumero(total["r_hora_regimental"] + total["r_hora_nao_regimental"] + total["r_hora_pago"])}</td>
                    <td>{utils.formataPercentualTotal(total, "hora")}</td>
                </tr>

            </Fragment>
        )
    }
}